import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { PrescriptionApi } from '../../../apis/PrescriptionApi/PrescriptionApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export interface ISendPrescriptionsToAssistantVariables {
    patientId: string;
    language: string;
}

export function useSendPrescriptionsToAssistant() {
    const { t } = useTranslation();

    return useMutation<{ assistantName: string; assistantEmail: string }, AppMedError, ISendPrescriptionsToAssistantVariables>({
        mutationKey: [QueryKeys.prescription, 'sendToAssistant'],
        mutationFn: async ({ patientId, language }) => {
            return await PrescriptionApi.sendPrescriptionsToAssistant(patientId, language);
        },
        onSuccess: (data) => {
            notifications.show({
                title: t('prescriptionHistory.notifications.sendToAssistantSuccess.title'),
                message: t('prescriptionHistory.notifications.sendToAssistantSuccess.message', {
                    name: data.assistantName || data.assistantEmail,
                }),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('prescriptionHistory.notifications.sendToAssistantError.title'),
                message: error?.message || t('prescriptionHistory.notifications.sendToAssistantError.message'),
                color: 'red',
            });
        },
    });
}
